import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function InstagramDownloader() {
  useEffect(() => {
    document.title = 'Instagram Video Downloader — Download Reels & Videos Free';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Download Instagram Reels, IGTV videos, and video posts in HD quality for free. Save Instagram videos directly to your device.');

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: 'How to Download Instagram Videos',
      step: [
        { '@type': 'HowToStep', position: 1, text: 'Open the Instagram post or Reel and copy the link via the share button.' },
        { '@type': 'HowToStep', position: 2, text: 'Paste the Instagram URL into HD Video Download.' },
        { '@type': 'HowToStep', position: 3, text: 'Click Download and save the video to your device.' },
      ],
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, []);

  return (
    <div className="app">
      <div className="container page-content">
        <Link to="/" className="back-link">&larr; Back to Downloader</Link>
        <h1 className="page-title">Instagram Video Downloader</h1>
        <p className="page-subtitle">Download Instagram Reels, IGTV, and video posts in HD quality.</p>

        <div className="cta-section" style={{ marginTop: '1.5rem', marginBottom: '2rem' }}>
          <Link to="/" className="cta-btn">Download Instagram Video Now</Link>
        </div>

        <h2 className="section-title">How to Download Instagram Videos</h2>
        <div className="steps">
          <div className="step"><span className="step-number">1</span><div><h3>Copy Instagram Link</h3><p>Open the Reel or video post in Instagram, tap the three dots (⋯) or share button, and select "Copy Link".</p></div></div>
          <div className="step"><span className="step-number">2</span><div><h3>Paste & Download</h3><p>Paste the Instagram URL into hdvideodownload.com and click "Download".</p></div></div>
          <div className="step"><span className="step-number">3</span><div><h3>Save to Device</h3><p>The video will be downloaded as an MP4 file to your device.</p></div></div>
        </div>

        <h2 className="section-title">Supported Content</h2>
        <div className="seo-features">
          <div className="seo-feature"><h3>Instagram Reels</h3><p>Download any public Instagram Reel in full quality as MP4.</p></div>
          <div className="seo-feature"><h3>Video Posts</h3><p>Save video posts from public Instagram profiles and pages.</p></div>
          <div className="seo-feature"><h3>IGTV Videos</h3><p>Download longer IGTV videos in HD quality for offline viewing.</p></div>
        </div>

        <div className="cta-section">
          <Link to="/" className="cta-btn">Download Instagram Videos Free</Link>
        </div>
      </div>
      <footer className="footer">
        <span>&copy; {new Date().getFullYear()} hdvideodownload.com — All rights reserved.</span>
        <a href="mailto:hdvideodownload44@gmail.com" className="footer-mail">hdvideodownload44@gmail.com</a>
      </footer>
    </div>
  );
}

export default InstagramDownloader;
